import React from "react"
import PropTypes from "prop-types"
// import "../../styles/styles.scss"
// import 'bootstrap/dist/css/bootstrap.min.css'
import Header from "../Header"
import DocumentsNav from "../DocumentsNav"
import { useCommonData } from "../../data/useCommonData"

import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuOpenIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import "./layoutDrawerStyles.scss"

const drawerWidth = 240

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  }),
);

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
}));

export default function LayoutDrawer({ children }) {
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const { site } = useCommonData()

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };
  
  return (
      <>
        <Header siteTitle={site.siteMetadata?.title || `Title`}
                siteDescription={site.siteMetadata?.description} />
        <Box sx={{ display: 'flex' }}>
          <IconButton onClick={handleDrawerOpen} sx={{ alignItems: 'flex-start', borderRadius: 0}}>
            <MenuOpenIcon />
          </IconButton>
          <Drawer className="layout-drawer" sx={{
            width: drawerWidth,
            flexShrink: 0,
            '& .MuiDrawer-paper': {
              width: drawerWidth,
              boxSizing: 'border-box',
              top: 'initial',
            },
          }} variant="persistent" anchor="left" open={open}>
            <DrawerHeader>
              <IconButton onClick={handleDrawerClose}>
                {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
              </IconButton>
            </DrawerHeader>
            <Divider />
            <DocumentsNav />
            <footer className="main-footer">
              © {new Date().getFullYear()}, Practice Alpha
            </footer>
          </Drawer>
          <Main open={open}>
            {children}
          </Main>
        </Box>

      </>
  )
}


LayoutDrawer.propTypes = {
  children: PropTypes.node,
}

